<div
  class="file-upload-placeholder-wrapper"
  fxLayout="row"
  fxLayoutAlign="center stretch"
>
  <div
    class="block title like-mat-form-field"
    [ngClass]="{ 'disabled-field': checked || !fileSelected }"
    [fxFlex]="layouts && layouts[0] ? layouts[0] : 50"
    fxLayout="row"
    fxLayoutAlign="space-between center"
    (click)="toggleCheckBox()"
  >
    <mat-label *ngIf="!noPlaceholder">
      {{ placeholder }}
    </mat-label>

    <mat-checkbox
      name="fileCheck"
      [checked]="checked"
      id="fileCheck"
      class="checkbox"
    ></mat-checkbox>
  </div>

  <span
    class="block button like-mat-form-field"
    [ngClass]="{ 'disabled-field': !fileSelected }"
    (click)="sendResultBack()"
    [fxFlex]="layouts && layouts[1] ? layouts[1] : 50"
    fxLayout="row"
    fxLayoutAlign="center center"
    matRipple
    [class.primary-bg]="color === 'primary'"
    [class.accent-bg]="color === 'accent'"
    [class.warn-bg]="color === 'warn'"
    [style.color]="color ? 'white' : 'black'"
  >
    <span> {{ uploadBtnTitle ? uploadBtnTitle : "انتخاب فایل" }} </span>
  </span>
</div>
